module.exports = __webpack_public_path__ + "static/media/PGH_AI.4eff0580.png";